import React, { useState, useEffect, useContext, useRef } from "react";
import DataTable from "../components/DataTableComponents";
import IconUI from "../components/iu/icon_ui";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import LoaderComponent from "../components/admin/LoaderComponent";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  Link,
  Menu,
  FormGroup,
  FormLabel,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import {
  AiOutlineSelect,
  AiOutlineDelete,
  AiOutlineSearch,
} from "react-icons/ai";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import { BsCircleFill, BsCheck2Circle } from "react-icons/bs";
import { GlobalContext } from "../context/global_context";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment/moment";
import { RiFileExcel2Line } from "react-icons/ri";
import { onlyNumber } from "../utils/inputsRules";
import { FaMapLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTable: {
        styleOverrides: {
          root: {
            borderRadius: "30px !important",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "#6A0F49 !important",
            color: "white",
          },
        },
      },
    },
  });

const PeticionesUser = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    // border: '2px solid #661d40',
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };
  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    // border: '2px solid #661d40',
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
    scrollbarWidth: "none",
  };
  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1200,
    bgcolor: "background.paper",
    // border: '2px solid #661d40',
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "90%",
    borderRadius: "40px",
  };
  const style4 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    // border: '2px solid #661d40',
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",
    //backgroundColor: ' #8d949e',
    "&:hover": {
      backgroundColor: "#661d40",
      //backgroundColor: ' #8d949e',
    },
    borderRadius: "40px",
  }));
  const { showNotification } = useContext(NotificacionContext);
  const goTo = useNavigate();

  // state del componente
  const [state, setState] = useState({
    peticiones: [],
    dependencias: [],
    tiposPeticion: [],
    detalles: [],
    adjuntos: [],
    openPeticion: false,
    openDetalles: false,
    openImprimir: false,
    openAdjuntos: false,
    openDocumento: false,
    openDescripcion: false,
    openEliminar: false,
    FilterChecked: true,
    peticionSeleccionada: {},
    documento: null,
    urlFrame: "",
    fonts: [],
  });

  const registro = localStorage.getItem("REGISTRO");
  const eliminar = localStorage.getItem("BORRAR_ASUNTO");
  const permiso = localStorage.getItem("EXPORTACIÓN");
  const permisoGeo = localStorage.getItem("GEOLOCALIZACION"); //permiso geolocalización

  //palabra de inicio
  const {
    filtro,
    filtro2,
    filtroUser,
    acuse,
    filtroLeida,
    dashboard,
    formularioGeo,
    setFormularioGeo,
  } = useContext(GlobalContext);

  const [formulario, setFormulario] = useState({
    openFiltro: false,
    municipios: [],
    localidades: [],
    cargos: [],
    titulos: [],

    ciudadano: null,
    apellido_paterno: null,
    apellido_materno: null,
    calle: null,
    colonia: null,
    cp: null,
    telefono: null,
    municipio_id: null,
    localidad_id: null,
    tipo_titulo_id: null,
    tipo_cargo_id: null,
    folio: null,
    atencion_inmediata: null,
    tipo_peticion_id: null,
    peticion: null,
    dependencia_id: null,
    tipo_gobierno: null,
    estatus_peticion_id: null,
    respuesta: null,
    observaciones: null,
    numero_gira: null,
    fecha_inicio: null,
    fecha_fin: null,
    edad_inicio: null,
    edad_fin: null,
    bandeja: 1,
    fuente_solicitud_id: "",
    tiene_solicitud: null,
    tiene_respuesta: null,
    leida: null,
    con_acuse: (acuse === null || acuse === undefined || acuse === "")
      ? null
      : (acuse === "SIN ACUSE" ? 0 : 1),
    dias_restantes: null
  });



  const fileInputRef = useRef(null);

  //modificar peticion

  const [errors, setErrors] = useState({});

  const openModalPeticion = async () => {
    setLoader({ ...loader, loading: true });
    const tiposPeticion = await services({
      method: "GET",
      service: "catTipoPeticiones/listarPeticiones",
      body: null,
    });
    const dependencias = await services({
      method: "GET",
      service: "dependencias/listar",
      body: null,
    });
    if (tiposPeticion.status === 200 && dependencias.status === 200) {
      setLoader({ ...loader, loading: false });
      setState({
        ...state,
        openPeticion: true,
        peticionSeleccionada: selectedItemId,
        tiposPeticion: tiposPeticion.data.data,
        dependencias: dependencias.data.data,
      });
      handleMenuClose();
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...",
        "Ocurrió algo al cargar la información",
        null,
        4
      );
      handleMenuClose();
    }
  };

  const openModalEliminar = () => {
    setState({
      ...state,
      openEliminar: true,
      peticionSeleccionada: selectedItemId,
    });
    handleMenuClose();
  };

  const openModalDetalles = async () => {
    setLoader({ ...loader, loading: true });
    let detalles = await services({
      method: "POST",
      service: `peticiones/mostrarPeticion`,
      body: { id: selectedItemId.id },
    });
    if (detalles.status === 200) {
      setLoader({ ...loader, loading: false });
      setState({ ...state, detalles: detalles.data.data, openDetalles: true });
      handleMenuClose();
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "ups... Algo sucedió",
        "Error al obtener información",
        null,
        4
      );
      handleMenuClose();
    }
  };

  const openModalDescripcion = (tipo, data) => {
    setState({
      ...state,
      openDescripcion: true,
      descripcion: tipo + " " + data,
    });
  };

  const openModalImprimir = () => {
    setState({
      ...state,
      openImprimir: true,
      peticionSeleccionada: selectedItemId.id,
    });
    handleMenuClose();
  };

  const openModalAdjuntos = async () => {
    setLoader({ ...loader, loading: true });
    let listaAdjuntos = await services({
      method: "POST",
      service: `documentos/listarAdjuntos`,
      body: { id: selectedItemId.id },
    });
    if (listaAdjuntos.status === 200) {
      setLoader({ ...loader, loading: false });
      setState({
        ...state,
        openAdjuntos: true,
        adjuntos: listaAdjuntos.data.data,
      });
      handleMenuClose();
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        "No se lograron cargar los archivos adjuntos",
        null,
        4
      );
    }
  };

  const openModalFiltro = async () => {
    setLoader({ ...loader, loading: true });
    let municipios = await services({
      method: "GET",
      service: `catMunicipios/listar`,
      body: null,
    });
    let cargos = await services({
      method: "GET",
      service: `catTipoCargos/listarCargos`,
      body: null,
    });
    let titulos = await services({
      method: "GET",
      service: `catTiposTitulos/listar`,
      body: null,
    });
    let fonts = await services({
      method: "GET",
      service: "catFuentesSolicitudes/listar",
      body: null,
    });
    let tiposPeticion = await services({
      method: "GET",
      service: "catTipoPeticiones/listarPeticiones",
      body: null,
    });
    let dependencias = await services({
      method: "GET",
      service: "dependencias/listar",
      body: null,
    });

    if (
      municipios.status === 200 &&
      cargos.status === 200 &&
      titulos.status === 200 &&
      tiposPeticion.status === 200 &&
      dependencias.status === 200 &&
      fonts.status === 200
    ) {
      setLoader({ ...loader, loading: false });
      setFormulario({
        ...formulario,
        municipios: municipios.data.data,
        cargos: cargos.data.data,
        titulos: titulos.data.data,
        openFiltro: true,
      });
      setBusqueda(true)
      setState({
        ...state,
        tiposPeticion: tiposPeticion.data.data,
        dependencias: dependencias.data.data,
        fonts: fonts.data.data,
      });
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups... algo sucedió",
        "Error al obtener información",
        null,
        4
      );
    }
  };

  const handleCloseFiltro = () => {
    setFormulario({
      ...formulario,
      openFiltro: false,
      tiene_respuesta: null,
      tiene_solicitud: null,
    });
  };

  //manejo inputs filtro

  const handleMunicipio = async (e) => {
    if (e === null) {
      setFormulario((formulario) => ({
        ...formulario,
        municipio: "",
        localidad: "",
      }));
    } else {
      let localidades = await services({
        method: "POST",
        service: `catLocalidades/listaPorMunicipio`,
        body: { municipio_id: e.id },
      });
      if (localidades.status === 200) {
        setFormulario((formulario) => ({
          ...formulario,
          municipio_id: e ? e.id : "",
          localidades: localidades.data.data,
          localidad_id: "",
        }));
      } else {
        showNotification("error", "Ups...", localidades.data.message, null, 4);
      }
    }
  };
  const handleLocalidad = (e) => {
    setFormulario({ ...formulario, localidad_id: e.target.value });
  };
  const handleCargo = (e) => {
    setFormulario((formularioState) => ({
      ...formularioState,
      tipo_cargo_id: e ? e.id : null,
    }));
  };
  const handleTitulo = (e) => {
    setFormulario({ ...formulario, tipo_titulo_id: e.target.value });
  };
  const handleTipoPeticionesFiltro = (e) => {
    setFormulario({ ...formulario, tipo_peticion_id: e ? e.id : null });
  };
  const handleDependenciasFiltro = (e) => {
    setFormulario((formulario) => ({
      ...formulario,
      dependencia_id: e ? e.id : null,
    }));
  };
  const handleTipoGobierno = (e) => {
    setFormulario({ ...formulario, tipo_gobierno: e.target.value });
  };
  const handleInicio = (e) => {
    const selectedDate = dayjs(e.$d);
    setFormulario({
      ...formulario,
      fecha_inicio: selectedDate.format("YYYY-MM-DD"),
    });
  };
  const handleFin = (e) => {
    const selectedDate = dayjs(e.$d);
    setFormulario({
      ...formulario,
      fecha_fin: selectedDate.format("YYYY-MM-DD"),
    });
  };
  //fin manejo inputs filtro

  const handleTipoPeticiones = (e) => {
    setState({
      ...state,
      peticionSeleccionada: {
        ...state.peticionSeleccionada,
        tipo_peticion_id: e ? e.id : null,
      },
    });
  };

  const handleDependencias = (e) => {
    setState({
      ...state,
      peticionSeleccionada: {
        ...state.peticionSeleccionada,
        dependencia_id: e ? e.id : null,
      },
    });
  };

  const handlePrioridad = (e) => {
    setState({
      ...state,
      peticionSeleccionada: {
        ...state.peticionSeleccionada,
        atencion_inmediata: e.target.value,
      },
    });
  };
  const handleStatusPeticion = (e) => {
    setState({
      ...state,
      peticionSeleccionada: {
        ...state.peticionSeleccionada,
        estatus_peticion_id: e.target.value,
        respuesta: "",
      },
    });
  };

  const handleDocumento = (e) => {
    setState({ ...state, documento: e.target.value });
  };
  const handleChangeFont = (e) => {
    setFormulario({ ...formulario, fuente_solicitud_id: e.target.value });
  };

  //state del loading
  const [loader, setLoader] = useState({
    loading: true,
  });

  const handleClosePeticion = () => {
    setState({ ...state, openPeticion: false });
    setErrors({});
  };

  const handleCloseEliminar = () => {
    setState({ ...state, openEliminar: false });
  };

  const handleCloseDetalles = () => {
    setState({ ...state, openDetalles: false });
  };

  const handleCloseDescripcion = () => {
    setState({ ...state, openDescripcion: false });
  };

  const handleCloseImprimir = () => {
    setState({ ...state, openImprimir: false });
  };

  const handleCloseDocumento = () => {
    setState({ ...state, openDocumento: false });
  };

  const handleCloseAdjuntos = () => {
    setState({ ...state, openAdjuntos: false });
    setSelectedFile(null);
  };

  const handleAcuse = async (id) => {
    setLoader({ ...loader, loading: true });
    let response = await services({
      method: "POST",
      service: `peticiones/generarAcuse`,
      body: { id: id },
    });
    if (response.status === 200) {
      let peticiones = await services({
        method: "POST",
        service: `peticiones/listarPeticiones/${rowsPerPage}?page=${page + 1}`,
        body: { ...formulario, cargos: [], municipios: [], titulos: [] },
      });
      if (peticiones.status === 200) {
        setState({ ...state, peticiones: peticiones.data.data.data });
        setTotalPeticiones(peticiones.data.data.total)
        setLoader({ ...loader, loading: false });
        showNotification("success", "Éxito", response.data.message, null, 4);
        handleMenuClose();
      } else {
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "ups... Algo sucedió",
          "Error al obtener información",
          null,
          4
        );
        handleMenuClose();
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "ups... Algo sucedió",
        response.data.message,
        null,
        4
      );
      handleMenuClose();
    }
  };

  const handleVerAcuse = (data) => {
    setState({ ...state, peticionSeleccionada: data });
    descargarDocumentos(5);
    handleMenuClose();
  };

  // manejo de archivos
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };
  // manejo de archivos

  //Botón de acciones

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setSelectedItemId(data);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  //Botón de acciones

  //columnas y lógica de la tabla
  const columns = [
    {
      name: "leida",
      label: "LEÍDAS",
      options: {
        filter: true,
        sort: true,
        display: false,
        filterList: (filtroLeida && filtroLeida !== "") ? [filtroLeida] : [],
        customFilterListOptions: { render: (v) => (v ? `${v}` : "") },
        customBodyRenderLite: (dataIndex) => {
          let leida = state.peticiones[dataIndex].leida;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {leida}
            </div>
          );
        },
      },
    },
    {
      name: "semaforo",
      label: " ",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let semaforo = state.peticiones[dataIndex].semaforo;
          if (semaforo === "ATENDIDA") {
            return (
              <div
                className="d-flex align-items-center"
                style={{ height: "30px" }}
              >
                <IconUI size={"20px"} color={"green"}>
                  <BsCheck2Circle />
                </IconUI>
              </div>
            );
          } else if (semaforo === "VERDE") {
            return (
              <div
                className="d-flex align-items-center"
                style={{ height: "30px" }}
              >
                <IconUI size={"20px"} color={"green"}>
                  <BsCircleFill />
                </IconUI>
              </div>
            );
          } else if (semaforo === "AMARILLO") {
            return (
              <div
                className="d-flex align-items-center"
                style={{ height: "30px" }}
              >
                <IconUI size={"20px"} color={"yellow"}>
                  <BsCircleFill />
                </IconUI>
              </div>
            );
          } else {
            return (
              <div
                className="d-flex align-items-center"
                style={{ height: "30px" }}
              >
                <IconUI size={"20px"} color={"red"}>
                  <BsCircleFill />
                </IconUI>
              </div>
            );
          }
        },
      },
    },
    {
      name: "acuse",
      label: "ACUSE",
      options: {
        filter: true,
        sort: true,
        display: false,
        filterList: (acuse && acuse !== "") ? [acuse] : [],
        customFilterListOptions: { render: (v) => (v ? `${v}` : "") },
        customBodyRenderLite: (dataIndex) => {
          let acuse = state.peticiones[dataIndex].acuse;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {acuse}
            </div>
          );
        },
      },
    },
    {
      name: "folio",
      label: "FOLIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let folio = state.peticiones[dataIndex].folio;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {folio}
            </div>
          );
        },
      },
    },
    {
      name: "fecha_creacion",
      label: "FECHA",
      options: {
        filter: true,
        sort: false,
        display: false,
        customBodyRenderLite: (dataIndex) => {
          let alta = moment(
            state.peticiones[dataIndex].fecha_creacion,
            "DD-MM-YYYY"
          );
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {" "}
              {alta.format("DD-MM-YYYY")}{" "}
            </div>
          );
        },
      },
    },
    {
      name: "fecha_creacion",
      label: "FECHA",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let alta = moment(
            state.peticiones[dataIndex].fecha_creacion,
            "DD-MM-YYYY"
          );
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {" "}
              {alta.format("DD-MM-YYYY")}{" "}
            </div>
          );
        },
        filterType: "custom",
        customFilterListOptions: {
          render: (v) => {
            if (v[0] && v[1] && state.FilterChecked) {
              return [`FECHA INICIO: ${v[0]}`, `FECHA FINAL: ${v[1]}`];
            } else if (v[0] && v[1] && !state.FilterChecked) {
              return `FECHA INICIO: ${v[0]}, FECHA FINAL: ${v[1]}`;
            } else if (v[0]) {
              return `FECHA INICIO: ${v[0]}`;
            } else if (v[1]) {
              return `FECHA FINAL: ${v[1]}`;
            }
            return [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, "");
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }

            return filterList;
          },
        },
        filterOptions: {
          names: [],
          logic(fecha_creacion, filters) {
            if (filters[0] && filters[1]) {
              return (
                dayjs(fecha_creacion).format("YYYY-MM-DD") < filters[0] ||
                dayjs(fecha_creacion).format("YYYY-MM-DD") > filters[1]
              );
            } else if (filters[0]) {
              return dayjs(fecha_creacion).format("YYYY-MM-DD") < filters[0];
            } else if (filters[1]) {
              return dayjs(fecha_creacion).format("YYYY-MM-DD") > filters[1];
            }
            return false;
          },
          display: (filterList, onChange, index, column) => (
            <div>
              <FormLabel className="mb-2" style={{ fontSize: "12px" }}>
                RANGO DE FECHAS
              </FormLabel>
              <FormGroup row>
                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="INICIO"
                    slotProps={{ textField: { size: "small" } }}
                    value={
                      filterList[index][0] ? dayjs(filterList[index][0]) : null
                    }
                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    onChange={(event) => {
                      filterList[index][0] = dayjs(event).format("YYYY-MM-DD");
                      onChange(filterList[index], index, column);
                    }}
                    style={{ width: "40%" }}
                  />
                </LocalizationProvider>

                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="FINAL"
                    slotProps={{ textField: { size: "small" } }}
                    value={
                      filterList[index][1] ? dayjs(filterList[index][1]) : null
                    }
                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    onChange={(event) => {
                      filterList[index][1] = dayjs(event).format("YYYY-MM-DD");
                      onChange(filterList[index], index, column);
                    }}
                    style={{ width: "40%", marginLeft: "10px" }}
                  />
                </LocalizationProvider>
              </FormGroup>
            </div>
          ),
        },
      },
    },
    {
      name: "ciudadano",
      label: "NOMBRE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let nombre = state.peticiones[dataIndex].ciudadano;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {nombre}
            </div>
          );
        },
      },
    },
    {
      name: "municipio",
      label: "MUNICIPIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let municipio = state.peticiones[dataIndex].municipio;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {municipio}
            </div>
          );
        },
      },
    },
    {
      name: "peticion",
      label: "PETICIÓN",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let descripcion = state.peticiones[dataIndex].peticion;
          let tipo = state.peticiones[dataIndex].tipo_peticion;
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center cursor-pointer "
              onClick={() => {
                openModalDescripcion(
                  state.peticiones[dataIndex].tipo_peticion,
                  state.peticiones[dataIndex].peticion
                );
              }}
            >
              {tipo
                ? tipo + " " + descripcion.substring(0, 30)
                : descripcion.substring(0, 30)}{" "}
              ...
            </div>
          );
        },
      },
    },
    {
      name: "dependencia",
      label: "DEPENDENCIA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let dependencia = state.peticiones[dataIndex].dependencia;
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {dependencia}
            </div>
          );
        },
      },
    },
    {
      name: "tipo_gobierno",
      label: "TIPO DE DEPENDENCIA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let dependencia = state.peticiones[dataIndex].tipo_gobierno;
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {dependencia}
            </div>
          );
        },
      },
    },
    {
      name: "estatus_peticion",
      label: "ESTADO",
      options: {
        filter: true,
        sort: false,
        filterList: [filtro, filtro2].filter(f => f && f !== ""),
        customFilterListOptions: { render: (v) => (v ? `${v}` : "") },
        customBodyRenderLite: (dataIndex) => {
          let estado = state.peticiones[dataIndex].estatus_peticion;
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {estado}
            </div>
          );
        },
      },
    },
    {
      name: "usuario",
      label: "USUARIO",
      options: {
        filter: true,
        sort: false,
        display: false,
        filterList: (filtroUser && filtroUser !== "") ? [filtroUser] : [],
        customFilterListOptions: { render: (v) => (v ? `${v}` : "") },
        customBodyRenderLite: (dataIndex) => {
          let estado = state.peticiones[dataIndex].usuario_registro;
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {estado}
            </div>
          );
        },
      },
    },
    {
      name: "respuesta",
      label: "RESPUESTA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let respuesta = state.peticiones[dataIndex].respuesta;
          if (respuesta !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center cursor-pointer"
                onClick={() => {
                  openModalDescripcion(
                    state.peticiones[dataIndex].respuesta,
                    ""
                  );
                }}
              >
                {respuesta.substring(0, 30)}
                ...
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "dias_restantes",
      label: "DIAS RESTANTES",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let dias = state.peticiones[dataIndex].dias_restantes;
          return (
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              {dias}
            </div>
          );
        },
      },
    },
    {
      name: "acciones",
      label: "ACCIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        display: registro || eliminar ? true : false,
        customBodyRenderLite: (dataIndex) => {
          return registro && eliminar ? (
            <div>
              <Button
                onClick={(event) =>
                  handleMenuClick(event, state.peticiones[dataIndex])
                }
              >
                <IconUI size={"20px"} color={"black"}>
                  <AiOutlineSelect />
                </IconUI>
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {(selectedItemId?.estatus_peticion_id === 4 ||
                  selectedItemId?.estatus_peticion_id === 6 ||
                  selectedItemId?.estatus_peticion_id === 9) &&
                  selectedItemId?.acuse === "SIN ACUSE" ? (
                  <MenuItem
                    onClick={() => {
                      handleAcuse(selectedItemId.id);
                    }}
                  >
                    GENERAR ACUSE
                  </MenuItem>
                ) : (
                  <div></div>
                )}
                <MenuItem onClick={openModalImprimir}>IMPRIMIR</MenuItem>
                <MenuItem onClick={openModalPeticion}>EDITAR</MenuItem>
                <MenuItem onClick={openModalAdjuntos}>ADJUNTOS</MenuItem>
                <MenuItem onClick={handleVerAcuse}>ACUSES</MenuItem>
                <MenuItem onClick={openModalDetalles}>DETALLES</MenuItem>
                <MenuItem onClick={openModalEliminar}>ELIMINAR</MenuItem>
              </Menu>
            </div>
          ) : registro ? (
            <div>
              <Button
                onClick={(event) =>
                  handleMenuClick(event, state.peticiones[dataIndex])
                }
              >
                <IconUI size={"20px"} color={"black"}>
                  <AiOutlineSelect />
                </IconUI>
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {(selectedItemId?.estatus_peticion_id === 4 ||
                  selectedItemId?.estatus_peticion_id === 6 ||
                  selectedItemId?.estatus_peticion_id === 9) &&
                  selectedItemId?.acuse === "SIN ACUSE" ? (
                  <MenuItem
                    onClick={() => {
                      handleAcuse(selectedItemId.id);
                    }}
                  >
                    GENERAR ACUSE
                  </MenuItem>
                ) : (
                  <div></div>
                )}
                <MenuItem onClick={openModalImprimir}>IMPRIMIR</MenuItem>
                <MenuItem onClick={openModalPeticion}>EDITAR</MenuItem>
                <MenuItem onClick={openModalAdjuntos}>ADJUNTOS</MenuItem>
                <MenuItem onClick={handleVerAcuse}>ACUSES</MenuItem>
                <MenuItem onClick={openModalDetalles}>DETALLES</MenuItem>
              </Menu>
            </div>
          ) : eliminar ? (
            <div>
              <Button
                onClick={(event) =>
                  handleMenuClick(event, state.peticiones[dataIndex])
                }
              >
                <IconUI size={"20px"} color={"black"}>
                  <AiOutlineSelect />
                </IconUI>
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={openModalEliminar}>ELIMINAR</MenuItem>
              </Menu>
            </div>
          ) : (
            <></>
          );
        },
      },
    },
  ];

  //Peticiones
  const mostrarPeticiones = async () => {
    setLoader({ ...loader, loading: true });
    let peticiones;
    if (dashboard === 0) {
      peticiones = await services({
        method: "POST",
        service: `peticiones/listarPeticiones/${rowsPerPage}?page=${page + 1}`,
        body: { ...formulario, cargos: [], municipios: [], titulos: [] },
      });

      if (peticiones.status === 200) {
        setTotalPeticiones(peticiones.data.data.total)
        setLoader({ ...loader, loading: false });
        setState({ ...state, peticiones: peticiones.data.data.data });
      } else {
        setLoader({ ...loader, loading: false });
      }
    } else {
      peticiones = await services({
        method: "POST",
        service: `peticiones/peticionesPorEstatus/${rowsPerPage}?page=${page + 1}`,
        body: { id_estatus: dashboard },
      });

      if (peticiones.status === 200) {
        setLoader({ ...loader, loading: false });
        setState({ ...state, peticiones: peticiones.data.data.data });
        setTotalPeticiones(peticiones.data.data.total)
      } else {
        setLoader({ ...loader, loading: false });
      }
    }
  };

  const service = {
    1: "documentos/oficioAyuntamiento",
    2: "documentos/oficioDependenciaEstatal",
    3: "documentos/oficioDependenciaFederal",
    4: "documentos/oficioOrganismosAutonomos",
    5: "documentos/acusePeticion",
    6: "documentos/respuestaPeticion",
  };

  const descargarDocumentos = async (type) => {
    setLoader({ ...loader, loading: true });
    const documento = service[type];
    let response = await services({
      method: "POST",
      service: `${documento}`,
      body: { id: selectedItemId.id },
    });
    if (response.status === 200) {
      let peticiones = await services({
        method: "POST",
        service: `peticiones/listarPeticiones/${rowsPerPage}?page=${page + 1}`,
        body: { ...formulario, cargos: [], municipios: [], titulos: [] },
      });
      if (peticiones.status === 200) {
        setTotalPeticiones(peticiones.data.data.total)
        setLoader({ ...loader, loading: false });
        setState({
          ...state,
          openDocumento: true,
          openImprimir: false,
          urlFrame: response.data.archivo,
          peticiones: peticiones.data.data.data,
        });
      } else {
        setLoader({ ...loader, loading: false });
        setState({ ...state, openImprimir: false });
        showNotification(
          "error",
          "Ups...Algo Sucedió",
          "No se actualizo la tabla",
          null,
          4
        );
      }
    } else {
      setLoader({ ...loader, loading: false });
      setState({ ...state, openImprimir: false });
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        response.data.message,
        null,
        4
      );
    }
  };

  const editarPeticion = async () => {
    setLoader({ ...loader, loading: true });
    if (state.peticionSeleccionada.respuesta === "") {
      let newErrors = {};
      newErrors.respuesta = "Este Campo es requerido";
      setErrors(newErrors);
      showNotification(
        "error",
        "Ups...",
        "Favor de rellenar los campos marcados",
        null,
        4
      );
      setLoader({ ...loader, loading: false });
      return Object.keys(newErrors).length === 0;
    } else {
      let response = await services({
        method: "POST",
        service: `peticiones/editarPeticion`,
        body: {
          id: state.peticionSeleccionada.id,
          peticion: state.peticionSeleccionada.peticion?.toUpperCase(),
          tipo_peticion_id: state.peticionSeleccionada.tipo_peticion_id,
          dependencia_id: state.peticionSeleccionada.dependencia_id,
          solicitud_id: state.peticionSeleccionada.solicitud_id,
          estatus_peticion_id: state.peticionSeleccionada.estatus_peticion_id,
          respuesta: state.peticionSeleccionada.respuesta?.toUpperCase(),
          atencion_inmediata: state.peticionSeleccionada.atencion_inmediata,
        },
      });
      if (response.status === 200) {
        let peticiones;
        if (dashboard === 0 || formulario.bandeja === 0) {
          peticiones = await services({
            method: "POST",
            service: `peticiones/listarPeticiones/${rowsPerPage}?page=${page + 1}`,
            body: { ...formulario, cargos: [], municipios: [], titulos: [] },
          });
        } else {
          peticiones = await services({
            method: "POST",
            service: `peticiones/peticionesPorEstatus/${rowsPerPage}?page=${page + 1}`,
            body: { id_estatus: dashboard },
          });
        }
        if (peticiones.status === 200) {
          setErrors({});
          setLoader({ ...loader, loading: false });
          setTotalPeticiones(peticiones.data.data.total)
          setState({
            ...state,
            peticiones: peticiones.data.data.data,
            openPeticion: false,
          });
          showNotification(
            "success",
            "Éxito",
            "Su petición ha sido editada",
            null,
            4
          );
        } else {
          setErrors({});
          setLoader({ ...loader, loading: false });
          setState({ ...state, openPeticion: false });
          showNotification(
            "error",
            "Ups...Algo Sucedió",
            peticiones.data.message,
            null,
            4
          );
        }
      } else {
        setErrors({});
        setLoader({ ...loader, loading: false });
        setState({ ...state, openPeticion: false });
        showNotification(
          "error",
          "Ups...Algo Sucedió",
          response.data.message,
          null,
          4
        );
      }
    }
  };

  const eliminarPeticion = async () => {
    setLoader({ ...loader, loading: true });
    let response = await services({
      method: "POST",
      service: `peticiones/eliminarPeticion`,
      body: {
        id: state.peticionSeleccionada.id,
      },
    });
    if (response.status === 200) {
      let peticiones;
      if (dashboard === 0 || formulario.bandeja === 0) {
        peticiones = await services({
          method: "POST",
          service: `peticiones/listarPeticiones/${rowsPerPage}?page=${page + 1}`,
          body: { ...formulario, cargos: [], municipios: [], titulos: [] },
        });
      } else {
        peticiones = await services({
          method: "POST",
          service: `peticiones/peticionesPorEstatus/${rowsPerPage}?page=${page + 1}`,
          body: { id_estatus: dashboard },
        });
      }
      if (peticiones.status === 200) {
        setLoader({ ...loader, loading: false });
        setState({
          ...state,
          peticiones: peticiones.data.data.data,
          openEliminar: false,
        });
        setTotalPeticiones(peticiones.data.data.total)
        showNotification(
          "success",
          "Éxito",
          "Su petición ha sido eliminada",
          null,
          4
        );
      } else {
        setLoader({ ...loader, loading: false });
        setState({ ...state, openEliminar: false });
        showNotification(
          "error",
          "Ups...Algo Sucedió",
          peticiones.data.message,
          null,
          4
        );
      }
    } else {
      setLoader({ ...loader, loading: false });
      setState({ ...state, openEliminar: false });
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        response.data.message,
        null,
        4
      );
    }
  };

  const enviarArchivos = async () => {
    setLoader({ ...loader, loading: true });
    if (selectedFile !== null) {
      const formData = new FormData();
      formData.append("id", selectedItemId.id);
      formData.append("archivo", selectedFile);
      let response = await services({
        method: "POST",
        service: `documentos/adjuntos`,
        body: formData,
      });
      if (response.status === 200) {
        let listaAdjuntos = await services({
          method: "POST",
          service: `documentos/listarAdjuntos`,
          body: { id: selectedItemId.id },
        });
        if (listaAdjuntos.status === 200) {
          setLoader({ ...loader, loading: false });
          setState({ ...state, adjuntos: listaAdjuntos.data.data });
          showNotification(
            "success",
            "Éxito",
            "Se ha cargado su archivo",
            null,
            4
          );
          setSelectedFile(null);
          fileInputRef.current.value = "";
        } else {
          setLoader({ ...loader, loading: false });
          showNotification(
            "error",
            "Ups...",
            "Ocurrió algo al cargar su archivo",
            null,
            4
          );
          setSelectedFile(null);
          handleCloseAdjuntos();
          fileInputRef.current.value = "";
        }
      } else {
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Error",
          response.data.message.archivo[0],
          null,
          4
        );
        setSelectedFile(null);
        handleCloseAdjuntos();
        fileInputRef.current.value = "";
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...",
        "Favor de seleccionar un archivo",
        null,
        4
      );
      setSelectedFile(null);
    }
  };

  const eliminarAdjunto = async (id_documento) => {
    Swal.fire({
      title: '¿Estás seguro de eliminar el adjunto?',
      text: "Esta acción no se puede deshacer",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then(async (result) => {

      if (result.isConfirmed) {
        setLoader({ ...loader, loading: true });
        const formData = new FormData();
        formData.append("id", id_documento);
        let response = await services({
          method: "POST",
          service: `documentos/eliminarAdjunto`,
          body: formData,
        });
        if (response.status === 200) {
          let listaAdjuntos = await services({
            method: "POST",
            service: `documentos/listarAdjuntos`,
            body: { id: selectedItemId.id },
          });
          if (listaAdjuntos.status === 200) {
            setState({ ...state, adjuntos: listaAdjuntos.data.data });
            setLoader({ ...loader, loading: false });
            showNotification(
              "success",
              "Éxito",
              "Se ha eliminado su archivo",
              null,
              4
            );
          }
        } else {
          setLoader({ ...loader, loading: false });
          showNotification(
            "error",
            "Ups...",
            "Ocurrió algo al eliminar su archivo",
            null,
            4
          );
          handleCloseAdjuntos();
        }
      }
    })
  };

  const descargarAdjunto = async (id_documento, name, tipo) => {
    setLoader({ ...loader, loading: true });
    const formData = new FormData();
    formData.append("id", selectedItemId.id);
    formData.append("id_documento", id_documento);
    formData.append("tipo_documento_id", tipo);
    let response = await services({
      method: "POST",
      service: `documentos/descargarDocumento`,
      body: formData,
    });
    if (response.status === 200) {
      setLoader({ ...loader, loading: false });
      showNotification(
        "success",
        "Éxito",
        "Se ha descargado su archivo",
        null,
        4
      );
      const link = document.createElement("a");
      link.href = `data:application/octet-stream;base64,${response.data.archivo}`;
      link.download = name;
      link.click();
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...",
        "Ocurrió algo al descargar su archivo",
        null,
        4
      );
    }
  };

  const exportar = async () => {
    setLoader({ ...loader, loading: true });
    let newForm = formulario;
    if (dashboard !== 0) {
      newForm.bandeja = 2;
      newForm.estatus_filtro = dashboard;
    }
    let response = await services(
      { method: "POST", service: `peticiones/exportar`, body: formulario },
      {
        responseType: "arraybuffer",
      }
    );
    if (response.status === 200) {
      setLoader({ ...loader, loading: false });
      showNotification(
        "success",
        "Éxito",
        "Se ha descargado su archivo",
        null,
        4
      );
      const link = document.createElement("a");
      link.href = `data:application/octet-stream;base64,${response.data.archivo}`;
      link.download = "Peticiones.xlsx";
      link.click();
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups...",
        "Ocurrió algo al descargar su archivo",
        null,
        4
      );
    }
  };

  const geolocalizacion = async () => {
    setLoader({ ...loader, loading: true });

    let newForm = formulario;
    if (dashboard !== 0) {
      newForm.bandeja = 2;
      newForm.estatus_filtro = dashboard;
    }
    localStorage.setItem("fomulario", JSON.stringify(formulario));
    goTo("/geolocalizacion");

    // let responseMapa = await services({ method: 'POST', service: `peticiones/geolocalizacion`, body: formulario })

    // if (responseMapa.status === 200) {
    //     setLoader({ ...loader, loading: false })
    //     setFormularioGeo(responseMapa.data)
    //     console.log(responseMapa.data.data, 'info')
    //     console.log(formularioGeo, "data")

    // }
  };

  const buscador = async () => {
    setLoader({ ...loader, loading: true });
    let peticiones = await services({
      method: "POST",
      service: `peticiones/listarPeticiones/${rowsPerPage}?page=${page + 1}`,
      body: { ...formulario, bandeja: 0, cargos: [], municipios: [], titulos: [] },
    });

    if (peticiones.status === 200) {
      setTotalPeticiones(peticiones.data.data.total)
      setLoader({ ...loader, loading: false });
      setState({ ...state, peticiones: peticiones.data.data.data });
      setFormulario({ ...formulario, openFiltro: false, bandeja: 0 });
    } else {
      setLoader({ ...loader, loading: false });
    }
  };

  const limpiarBuscador = () => {
    setFormulario({
      ...formulario,
      openFiltro: true,
      municipios: [],
      localidades: [],
      cargos: [],
      titulos: [],
      ciudadano: null,
      apellido_paterno: null,
      apellido_materno: null,
      calle: null,
      colonia: null,
      cp: null,
      telefono: null,
      municipio_id: null,
      localidad_id: null,
      tipo_titulo_id: null,
      tipo_cargo_id: null,
      folio: null,
      atencion_inmediata: null,
      tipo_peticion_id: null,
      peticion: null,
      dependencia_id: null,
      tipo_gobierno: null,
      estatus_peticion_id: null,
      respuesta: null,
      observaciones: null,
      numero_gira: null,
      fecha_inicio: null,
      fecha_fin: null,
      edad_inicio: null,
      edad_fin: null,
      tiene_respuesta: null,
      tiene_solicitud: null,
      con_acuse: null,
      leida: null,
      dias_restantes: null
    });
  };

  const [totalPeticiones, setTotalPeticiones] = useState(0)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [busqueda, setBusqueda] = useState(false)
  const isFirstRender = useRef(true);

  useEffect(() => {
    mostrarPeticiones();
    // eslint-disable-next-line
  }, [dashboard]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (busqueda) {
      buscador();
    } else {
      mostrarPeticiones()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage, page]);

  const customOptions = {
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    serverSide: true,
    count: totalPeticiones,
    page,
    rowsPerPage,
    onTableChange: async (action, tableState) => {
      if (action === "changePage") {
        setPage(tableState.page);
      }
      if (action === "changeRowsPerPage") {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      }
    },
    rowsPerPageOptions: totalPeticiones > 10 ? [10, 25, 50, 100] : [],
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
        toolTip: "Clasificar",
        columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
      },
      pagination: {
        rowsPerPage: "Filas por página:"
      }
    },
  };

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}

        <div className="container">
          <Grid
            sx={{ marginTop: 3 }}
            container
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={2}
          >
            <Grid item>
              <ColorButton
                startIcon={<AiOutlineSearch />}
                onClick={openModalFiltro}
              >
                Filtro
              </ColorButton>
            </Grid>
            {permiso ? (
              <Grid item>
                <ColorButton
                  startIcon={<RiFileExcel2Line />}
                  onClick={exportar}
                >
                  exportar
                </ColorButton>
              </Grid>
            ) : (
              <></>
            )}
            {permisoGeo ? (
              <Grid item>
                <ColorButton
                  startIcon={<FaMapLocationDot className="ms-1" />}
                  onClick={geolocalizacion}
                >
                  Geolocalización
                </ColorButton>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </div>

        <Grid className="container mt-3 mb-3" maxWidth="xl">
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              data={Array.isArray(state.peticiones) ? state.peticiones : (state.peticiones?.data || [])}
              title={`TABLA DE PETICIONES`}
              columns={columns}
              options={customOptions}
            />
          </ThemeProvider>
        </Grid>

        {/* Modal para Filtro Especial */}
        <Modal
          open={formulario.openFiltro}
          onClose={handleCloseFiltro}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style4}>
            <h5 className="TitulosProgramas">DATOS DEL PETICIONARIO</h5>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="NOMBRE"
                  variant="outlined"
                  value={formulario.ciudadano}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, ciudadano: target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="A.PATERNO"
                  variant="outlined"
                  value={formulario.apellido_paterno}
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      apellido_paterno: target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="A.MATERNO"
                  variant="outlined"
                  value={formulario.apellido_materno}
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      apellido_materno: target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="CALLE"
                  variant="outlined"
                  value={formulario.calle}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, calle: target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="COLONIA"
                  variant="outlined"
                  value={formulario.colonia}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, colonia: target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="CP"
                  variant="outlined"
                  value={formulario.cp}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, cp: target.value })
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 5 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="TELÉFONO"
                  variant="outlined"
                  value={formulario.telefono}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, telefono: target.value })
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Autocomplete
                  options={formulario.municipios || []}
                  getOptionLabel={(option) => option.municipio}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px", // Aplicamos borderRadius solo a TextField
                  }}
                  value={
                    formulario.municipios.find(
                      (option) => option.id === formulario.municipio_id
                    ) || null
                  }
                  onChange={(event, newValue) => handleMunicipio(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="MUNICIPIO"
                      error={!!errors.municipio}
                      helperText={errors.municipio || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="LOCALIDAD"
                  variant="outlined"
                  select
                  onChange={handleLocalidad}
                  value={formulario.localidad_id}
                >
                  {formulario.localidades?.length > 0 ? (
                    formulario.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.localidad}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value={null}>
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Autocomplete
                  options={formulario.cargos || []}
                  getOptionLabel={(option) => option.tipo_cargo}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px", // Aplicamos borderRadius solo a TextField
                  }}
                  value={
                    formulario.cargos.find(
                      (option) => option.id === formulario.tipo_cargo_id
                    ) || null
                  }
                  onChange={(event, newValue) => handleCargo(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="CARGO"
                      error={!!errors.cargo}
                      helperText={errors.cargo || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="TITULO"
                  variant="outlined"
                  select
                  onChange={handleTitulo}
                  value={formulario.tipo_titulo_id}
                >
                  {formulario.titulos &&
                    formulario.titulos.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.tipo_titulo}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={2}>
                <TextField
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label=" DE EDAD"
                  variant="outlined"
                  value={formulario.edad_inicio}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, edad_inicio: target.value })
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 3 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={2}>
                <TextField
                  fullWidth
                  size="small"
                  label=" A EDAD"
                  id="textFile-nombre"
                  variant="outlined"
                  value={formulario.edad_fin}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, edad_fin: target.value })
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 3 }}
                />
              </Grid>
            </Grid>

            <h5 className="TitulosProgramas mt-3">DATOS DE LA PETICIÓN</h5>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="FOLIO"
                  variant="outlined"
                  value={formulario.folio}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, folio: target.value })
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 5 }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="PRIORIDAD"
                  variant="outlined"
                  select
                  error={!!errors.atencion}
                  helperText={errors.atencion || ""}
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      atencion_inmediata: target.value,
                    })
                  }
                  value={formulario.atencion_inmediata}
                >
                  <MenuItem value={1}>INMEDIATA</MenuItem>
                  <MenuItem value={0}>ALTA</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="FUENTES"
                  variant="outlined"
                  select
                  error={!!errors.font}
                  helperText={errors.font || ""}
                  onChange={handleChangeFont}
                  value={formulario.fuente_solicitud_id}
                >
                  {state.fonts.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.fuente_solicitud}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  options={state.tiposPeticion || []}
                  getOptionLabel={(option) => option.tipo_peticion}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px", // Aplicamos borderRadius solo a TextField
                  }}
                  value={
                    state.tiposPeticion.find(
                      (option) => option.id === formulario.tipo_peticion_id
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    handleTipoPeticionesFiltro(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="TIPO DE PETICIÓN"
                      error={!!errors.tipo}
                      helperText={errors.tipo || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="DESCRIPCIÓN"
                  variant="outlined"
                  value={formulario.peticion}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, peticion: target.value })
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  options={state.dependencias || []}
                  getOptionLabel={(option) => option.dependencia}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px", // Aplicamos borderRadius solo a TextField
                  }}
                  value={
                    state.dependencias.find(
                      (option) => option.id === formulario.dependencia_id
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    handleDependenciasFiltro(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="DEPENDENCIAS"
                      error={!!errors.dependencia}
                      helperText={errors.dependencia || ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="TIPO DE GOBIERNO"
                  variant="outlined"
                  select
                  value={formulario.tipo_gobierno}
                  onChange={handleTipoGobierno}
                >
                  <MenuItem value="FEDERAL">FEDERAL</MenuItem>
                  <MenuItem value="ESTATAL">ESTATAL</MenuItem>
                  <MenuItem value="MUNICIPAL">MUNICIPAL</MenuItem>
                  <MenuItem value="AUTONOMO">AUTÓNOMO</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="ESTADO"
                  variant="outlined"
                  select
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      estatus_peticion_id: target.value,
                    })
                  }
                  value={formulario.estatus_peticion_id}
                >
                  <MenuItem value={1}>TURNADA</MenuItem>
                  <MenuItem value={4}>ATENDIDA POSITIVA</MenuItem>
                  <MenuItem value={5}>NO CORRESPONDE</MenuItem>
                  <MenuItem value={6}>NO PROCEDENTE</MenuItem>
                  <MenuItem value={7}>ARCHIVO</MenuItem>
                  <MenuItem value={8}>EN TRAMITE</MenuItem>
                  <MenuItem value={9}>CANCELADO</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="RESPUESTA"
                  variant="outlined"
                  value={formulario.respuesta}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, respuesta: target.value })
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="OBSERVACIONES"
                  variant="outlined"
                  value={formulario.observaciones}
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      observaciones: target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="N° GIRA"
                  variant="outlined"
                  value={formulario.numero_gira}
                  onChange={({ target }) =>
                    setFormulario({ ...formulario, numero_gira: target.value })
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="INICIO"
                    slotProps={{ textField: { size: "small" } }}
                    sx={{ width: 1 }}
                    // slotProps={{ textField: { helperText: 'Please fill this field' } }}
                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    value={
                      formulario.fecha_inicio !== null
                        ? dayjs(formulario.fecha_inicio)
                        : null
                    }
                    onChange={handleInicio}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={4}>
                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="FIN"
                    slotProps={{ textField: { size: "small" } }}
                    sx={{ width: 1 }}
                    // slotProps={{ textField: { helperText: 'Please fill this field' } }}
                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    value={
                      formulario.fecha_fin !== null
                        ? dayjs(formulario.fecha_fin)
                        : null
                    }
                    onChange={handleFin}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="LEÍDA"
                  variant="outlined"
                  select
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      leida: target.value,
                    })
                  }
                  value={formulario.leida}
                >
                  <MenuItem value={0}>NO LEÍDA</MenuItem>
                  <MenuItem value={1}>LEÍDA</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="ACUSE"
                  variant="outlined"
                  select
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      con_acuse: target.value,
                    })
                  }
                  value={formulario.acuse}
                >
                  <MenuItem value={0}>SIN ACUSE</MenuItem>
                  <MenuItem value={1}>CON ACUSE</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="DÍAS RESTANTES"
                  variant="outlined"
                  onKeyDown={onlyNumber}
                  inputProps={{ maxLength: 5 }}
                  onChange={({ target }) =>
                    setFormulario({
                      ...formulario,
                      dias_restantes: target.value,
                    })
                  }
                  value={formulario.dias_restantes}
                />
              </Grid>
              {registro ? (
                <> <Grid item xs={12} sm={12} md={12} lg={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formulario.tiene_solicitud === 1}
                        // indeterminate={formulario.tiene_solicitud === null}
                        onChange={(e) => {
                          const value1 = e.target.checked ? 1 : null;
                          setFormulario({
                            ...formulario,
                            tiene_solicitud: value1,
                          });
                          // console.log(value1, "check 1")
                        }}
                        name="tiene_solicitud"
                      />
                    }
                    label="PETICIONES SIN SOLICITUD ADJUNTA"
                  />
                </Grid>
                  {/* <Grid item xs={12} sm={12} md={12} lg={4} className="mb-2">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formulario.tiene_respuesta === 1}
                      // indeterminate={formulario.tiene_respuesta === null}
                      onChange={(e) => {
                        const value2 = e.target.checked ? 1 : null;
                        setFormulario({
                          ...formulario,
                          tiene_respuesta: value2,
                        });
                        // console.log(value2, "check2")
                      }}
                      name="tiene_respuesta"
                    />
                  }
                  label="PETICIONES SIN RESPUESTA DE DEPENDENCIA ADJUNTA"
                />
              </Grid> */}
                </>
              ) : (
                <>
                </>
              )}
            </Grid>
            <Grid marginLeft="auto" marginBottom={2} item>
              <ColorButton
                className="me-2"
                onClick={() => {
                  limpiarBuscador();
                }}
              >
                LIMPIAR
              </ColorButton>
              <ColorButton
                onClick={() => {
                  buscador();
                }}
              >
                BUSCAR
              </ColorButton>
            </Grid>
          </Box>
        </Modal>
        {/* Modal para editar peticion */}
        <Modal
          open={state.openPeticion}
          onClose={() => handleClosePeticion()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas mb-4">EDITAR PETICIÓN</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <Autocomplete
                  options={state.tiposPeticion || []}
                  getOptionLabel={(option) => option.tipo_peticion}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px", // Aplicamos borderRadius solo a TextField
                  }}
                  value={
                    state.tiposPeticion.find(
                      (option) =>
                        option.id ===
                        state.peticionSeleccionada.tipo_peticion_id
                    ) || null
                  }
                  onChange={(event, newValue) => handleTipoPeticiones(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="TIPO DE PETICIÓN"
                      error={!!errors.tipo}
                      helperText={errors.tipo || ""}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  size="small"
                  label="PETICIÓN"
                  error={!!errors.peticion}
                  rows={4}
                  helperText={errors.peticion || ""}
                  value={state.peticionSeleccionada.peticion}
                  onChange={({ target }) =>
                    setState({
                      ...state,
                      peticionSeleccionada: {
                        ...state.peticionSeleccionada,
                        peticion: target.value,
                      },
                    })
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  options={state.dependencias || []}
                  getOptionLabel={(option) => option.dependencia}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px", // Aplicamos borderRadius solo a TextField
                  }}
                  value={
                    state.dependencias.find(
                      (option) =>
                        option.id === state.peticionSeleccionada.dependencia_id
                    ) || null
                  }
                  onChange={(event, newValue) => handleDependencias(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      label="DEPENDENCIAS"
                      error={!!errors.dependencia_id}
                      helperText={errors.dependencia_id || ""}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="PRIORIDAD"
                  variant="outlined"
                  select
                  error={!!errors.atencion}
                  helperText={errors.atencion || ""}
                  onChange={handlePrioridad}
                  value={state.peticionSeleccionada.atencion_inmediata}
                >
                  <MenuItem value={1}>INMEDIATA</MenuItem>
                  <MenuItem value={0}>ALTA</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="ESTADO"
                  variant="outlined"
                  select
                  error={!!errors.atencion}
                  helperText={errors.atencion || ""}
                  onChange={handleStatusPeticion}
                  value={state.peticionSeleccionada.estatus_peticion_id}
                >
                  <MenuItem value={1}>TURNADA</MenuItem>
                  <MenuItem value={4}>ATENDIDA POSITIVA</MenuItem>
                  <MenuItem value={5}>NO CORRESPONDE</MenuItem>
                  <MenuItem value={6}>NO PROCEDENTE</MenuItem>
                  <MenuItem value={7}>ARCHIVO</MenuItem>
                  <MenuItem value={8}>EN TRAMITE</MenuItem>
                  <MenuItem value={9}>CANCELADO</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  size="small"
                  label="RESPUESTA"
                  error={!!errors.respuesta}
                  rows={4}
                  helperText={errors.respuesta || ""}
                  value={state.peticionSeleccionada.respuesta}
                  onChange={({ target }) =>
                    setState({
                      ...state,
                      peticionSeleccionada: {
                        ...state.peticionSeleccionada,
                        respuesta: target.value,
                      },
                    })
                  }
                />
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    editarPeticion();
                  }}
                >
                  Guardar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        {/* Modal para ver detalles */}
        <Modal
          open={state.openDetalles}
          onClose={() => handleCloseDetalles()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas mb-4">DETALLES</h3>
            <Grid container columns={12} spacing={3}>
              <span className=""></span>
              <Grid item xs={12}>
                <h5 className="mt-3 border-bottom">DATOS SOLICITUD</h5>
              </Grid>

              <Grid item xs={12}>
                <p>FOLIO: {state.detalles.folio_solicitud}</p>
                <p>FECHA CREACIÓN: {state.detalles.fecha_creacion_solicitud}</p>
                <p>FUENTE DE SOLICITUD: {state.detalles.fuente_solicitud}</p>
                <p>OBSERVACIONES: {state.detalles.observaciones}</p>
                <p>NÚMERO DE GIRA: {state.detalles.numero_gira}</p>
                <p>LUGAR DE GIRA: {state.detalles.lugar_gira}</p>
              </Grid>

              <Grid item xs={12}>
                <h5 className="mt-2 border-bottom">DATOS PETICIÓN</h5>
              </Grid>

              <Grid item xs={12}>
                <p>FOLIO: {state.detalles.folio}</p>
                <p>ALTA: {state.detalles.fecha_creacion}</p>
                <p>USUARIO DE REGISTRO: {state.detalles.usuario_registro}</p>
                <p>CIUDADANO: {state.detalles.ciudadano}</p>
                <p>CARGO: {state.detalles.cargo_ciudadano}</p>
                <p>DIRECCIÓN: {state.detalles.Direccion}</p>
                <p>TELÉFONO: {state.detalles.telefono}</p>
                <p>DEPENDENCIA: {state.detalles.dependencia}</p>
                <p>
                  DESCRIPCIÓN:{" "}
                  {state.detalles.tipo_peticion
                    ? state.detalles.tipo_peticion +
                    " " +
                    state.detalles.peticion
                    : state.detalles.peticion}
                </p>
                <p>ESTADO: {state.detalles.estatus_peticion}</p>
                <p>RESPUESTA: {state.detalles.respuesta}</p>
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    handleCloseDetalles();
                  }}
                >
                  Cerrar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        {/* Modal para imprimir oficios */}
        <Modal
          open={state.openImprimir}
          onClose={() => handleCloseImprimir()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style2}>
            <h3 className="TitulosProgramas mb-4">Oficios</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Fuentes"
                  label="Tipo de Oficio"
                  variant="outlined"
                  select
                  onChange={handleDocumento}
                  value={state.documento}
                >
                  <MenuItem value={1}>OFICIO PARA AYUNTAMIENTOS</MenuItem>
                  <MenuItem value={2}>OFICIO PARA DEPENDENCIA ESTATAL</MenuItem>
                  <MenuItem value={3}>OFICIO PARA DEPENDENCIA FEDERAL</MenuItem>
                  <MenuItem value={4}>OFICIO PARA ORGANISMO AUTÓNOMO</MenuItem>
                  <MenuItem value={6}>Oficio Respuesta Petición</MenuItem>
                </TextField>
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    descargarDocumentos(state.documento);
                  }}
                >
                  GENERAR
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        {/* Modal para ver documento */}
        <Modal
          open={state.openDocumento}
          onClose={() => handleCloseDocumento()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style3}>
            <p className="text-center">DOCUMENTO</p>
            <iframe
              style={{ width: "100%", height: "100%" }}
              title="DOCUMENTO"
              id="frameAceptacion"
              src={`data:application/pdf;base64,${state.urlFrame}`}
              className="preview-iframe"
            ></iframe>
            <Button sx={{ mt: 2 }} onClick={() => handleCloseDocumento()}>
              Cerrar
            </Button>
          </Box>
        </Modal>
        {/* Modal para ver Adjuntos */}
        <Modal
          open={state.openAdjuntos}
          onClose={() => handleCloseAdjuntos()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style2}>
            <h3 className="TitulosProgramas mb-4">Archivos Adjuntos</h3>
            <Grid container columns={12} spacing={2}>
              {state.adjuntos ? (
                state.adjuntos.map((adjunto, item) => {
                  return (
                    <Grid item xs={12}>
                      <Grid
                        container
                        spacing={2}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Grid item xs={9}>
                          {" "}
                          <Link
                            href={adjunto.ruta}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="always"
                          >
                            {adjunto.nombre}
                          </Link>
                        </Grid>
                        <Grid item xs={2}>
                          {adjunto.eliminar === 1 ? (
                            <Button
                              onClick={() => {
                                eliminarAdjunto(adjunto.id);
                              }}
                            >
                              <IconUI size={"20px"} color={"red"}>
                                <AiOutlineDelete />
                              </IconUI>
                            </Button>
                          ) : (
                            <></>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })
              ) : (
                <></>
              )}

              <Grid item xs={12}>
                <input
                  accept="image/png, application/pdf, image/jpg, image/jpng"
                  style={{ display: "none" }}
                  id="file-upload-input"
                  type="file"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
                <label htmlFor="file-upload-input">
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    startIcon={<CloudUploadIcon />}
                  >
                    Subir Archivo
                  </Button>
                </label>
                {selectedFile && (
                  <div>
                    <p>Nombre del archivo: {selectedFile.name}</p>
                  </div>
                )}
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    enviarArchivos();
                  }}
                >
                  Enviar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        {/* Modal para ver descripción/respuesta */}
        <Modal
          open={state.openDescripcion}
          onClose={() => handleCloseDescripcion()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style2}>
            <Grid container columns={12} spacing={2}>
              <Grid item xs={12}>
                <p>{state.descripcion}</p>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        {/* Modal para eliminar peticion */}
        <Modal
          open={state.openEliminar}
          onClose={() => handleCloseEliminar()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style2}>
            <h3 className="TitulosProgramas mb-3">
              ¿ESTÁ SEGURO DE ELIMINAR LA PETICIÓN?
            </h3>

            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <h4>FOLIO: {state.peticionSeleccionada.folio}</h4>
                <h6>DESCRIPCIÓN:{state.peticionSeleccionada.peticion} </h6>
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    eliminarPeticion();
                  }}
                >
                  Eliminar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default PeticionesUser;
